window.addEventListener('load', event => {
    // FAQ Panel accordions
    let faqPanels = document.querySelectorAll('.faq-panel');
    for (let faqPanel of faqPanels) {
        let accordions = faqPanel.querySelectorAll('.accordion');
        let extraCards = faqPanel.querySelectorAll('.faq-extra-card');
        let showMoreButton = faqPanel.querySelectorAll('.faq-load-more-button');

        for (let button of showMoreButton) {
            let buttonShowMoreText = button.dataset.showmoretext.toUpperCase();
            let buttonShowLessText = button.dataset.showlesstext.toUpperCase();

            button.addEventListener('click', event => {
                if (button.innerText.toUpperCase() === buttonShowMoreText) {
                    for (let card of extraCards) {
                        button.innerText = buttonShowLessText;
                        card.classList.remove('faq-extra-card', '!h-0', '!-mt-4', 'overflow-hidden', 'pointer-events-none', 'select-none', '!opacity-0');
                    }
                } else {
                    for (let card of extraCards) {
                        button.innerText = buttonShowMoreText;
                        card.classList.add('faq-extra-card', '!h-0', '!-mt-4', 'overflow-hidden', 'pointer-events-none', 'select-none', '!opacity-0');
                    }
                }
            })
        }

        for (let accordion of accordions) {
            let accordionToggle = accordion.querySelector('.accordion-visible');
            let accordionHidden = accordion.querySelector('.accordion-hidden');
            let accordionIcon = accordion.querySelector('.accordion-icon-p1');
            let accordionQuestionText = accordion.querySelector('.accordion-question-text')
            let accordionShowMoreLessText = accordion.querySelector('.accordion-show-more-less-text');
            let accordionHiddenHeight = 0;
            let locked = false;
            let resetAccordionDebounce =  _debounce(resetAccordion, 50, {leading: true, trailing: true});
            let accordionWidth = accordion.offsetWidth;

            accordionToggle.addEventListener('click', event => {
                accordionWidth = accordion.offsetWidth;
                if (event.target === accordionHidden || accordionHidden.contains(event.target)) {
                    return;
                }
                let open = accordionShowMoreLessText.innerHTML === accordionShowMoreLessText.dataset.showlesstext;

                if (open && !locked) {
                    // resets accordion to closed state / removes related event listener
                    accordionShowMoreLessText.innerHTML = accordionShowMoreLessText.dataset.showmoretext;
                    accordionIcon.classList.remove('!h-[.125rem]');
                    accordionHidden.classList.add('!h-0');
                    accordionQuestionText.classList.remove('text-green-pale');
                    window.removeEventListener('resize', resetAccordionDebounce);
                } else {
                    // sets accordion to open state / locks to prevent multiple event listeners being added.
                    locked = true;
                    accordionShowMoreLessText.innerHTML = accordionShowMoreLessText.dataset.showlesstext;
                    accordionIcon.classList.add('!h-[.125rem]');
                    accordionQuestionText.classList.add('text-green-pale');

                    // calcs what accordion height would be when open
                    accordionHidden.classList.remove('transition-all');
                    accordionHidden.classList.remove('!h-0');
                    accordionHidden.removeAttribute('style');
                    accordionHiddenHeight = accordionHidden.offsetHeight;
                    accordionHidden.classList.add('!h-0');

                    // transitions to calculated height
                    // adds debounced event listener to close on resize as height is now set
                    setTimeout(() => {
                        accordionHidden.classList.add('transition-all');
                        accordionHidden.setAttribute('style',`height:${accordionHiddenHeight}px`);
                        window.addEventListener('resize', resetAccordionDebounce, {passive: true})
                        accordionHidden.classList.remove('!h-0');
                        locked = false;
                    }, 50);
                }
            });

            // On resize removes added event listener and resets open accordion to closed state
            // was going to adjust height initially hence debounce - just resetting for now
            function resetAccordion() {
                if (accordion.offsetWidth != accordionWidth) {
                    accordionShowMoreLessText.innerHTML = accordionShowMoreLessText.dataset.showmoretext;
                    accordionIcon.classList.remove('!h-[.125rem]');
                    accordionHidden.classList.add('!h-0');
                    accordionQuestionText.classList.remove('text-green-pale');
                    window.removeEventListener('resize', resetAccordionDebounce);
                }
            }
        }
    }
});